import { observer } from 'mobx-react';
import { currentUserStore } from '../../CurrentUserStore';
import LeftSideComponents from '../Components/LeftSideComponents';
import RightSideComponents from '../Components/RightSideComponents';
import TopBar from '../Components/Topbar';

function Display() {
  return (
    <>
      <TopBar userName={currentUserStore.name} />
      <div className="flex">
        <LeftSideComponents />
        <RightSideComponents />
      </div>
    </>
  );
}

export default observer(Display);
